import ReactDOM from "react-dom";
import { UAParser } from "ua-parser-js";

import * as serviceWorker from "./serviceWorker";

import "bulma/css/bulma.min.css";
import "./responsive.css";
import "dayjs/locale/ja";
import { App } from "App";

const isSupportBrowser = (browserName?: string) => {
  switch (browserName) {
    case "IE":
    case undefined:
      return false;
    default:
      return true;
  }
};

const browser = new UAParser().getResult().browser.name;
if (isSupportBrowser(browser)) {
  ReactDOM.render(<App />, document.getElementById("root"));
} else {
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  document.getElementById("root")!.innerHTML =
    "お使いのブラウザからはご利用頂けません。";
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
